import React, { createContext, useContext, useState } from "react";
const DataContext = createContext();

export default function Context({ children }) {
  const [img, setImg] = useState("crypto");
  const [project, setProject] = useState("Crypto");
  const [url, setUrl] = useState("crypto");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [cards, setCards] = useState();
  return (
    <DataContext.Provider
      value={{
        img,
        setImg,
        project,
        setProject,
        url,
        setUrl,
        loading,
        setLoading,
        data,
        setData,
        cards,
        setCards,
      }}
    >
      {children}
    </DataContext.Provider>
  );
}

export const useDataContext = () => {
  const data = useContext(DataContext);
  return data;
};
